import styled from "styled-components";

const StyledHeader = styled.header`
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  position: relative;
  z-index: 2;

  .mcpTooltip {
    border: solid 0.5px;
  }

  .titleContainer {
    display: flex;
    align-items: center;

    .titleContainerBack {
      height: 24px;
      background: transparent;
      border: none;
      cursor: pointer;
      margin-right: 20px;

      svg {
        path {
          fill: #1d3468;
        }
      }
    }
  }

  .lngDropdown {
    position: absolute;
    right: 10px;

    .flagDropdownWrapper {
      width: unset;
      .shownFlag {
        box-shadow: none;
      }
    }
  }

  .tokenContainerMessage {
    margin-right: 10px;
    color: #757575;

    b {
      margin-left: 3px;
    }
  }

  .memberHistory {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 4px;
    border: 0.5px solid #1568bf;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    margin: 0 10px 0 0;
    color: #1568bf;
    background: #fff;
    transition: 0.5s;

    svg {
      margin-right: 5px;
    }

    &:hover {
      background: #1568bf;
      color: #fff;
    }
  }

  .headerTitle {
    font-size: 22px;
    font-weight: 600;
    color: #1d3468;
    line-height: 26.82px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .mobileTokens {
    display: none;
    background: #fff;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
    padding: 8px 10px;
    border-radius: 16px;

    .tooltip {
      background: #282a3b !important;
      border: 1px solid #282a3b !important;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 500;
      line-height: 1.85;
      color: #ffffff;
      text-align: center;
      padding: 0 8px;
    }

    .tooltip:after {
      border-top: 8px solid #1568bf !important;
      margin-left: -3px !important;
      bottom: -7px;
    }

    .__react_component_tooltip.show {
      opacity: 0.9 !important;
      margin-top: -10px !important;
      margin-left: 0px !important;
      visibility: visible;
    }

    .__react_component_tooltip.show.tokenState {
      left: 299px !important;
      top: 14px !important;
      width: 336px;
    }
  }

  .tokenUserContainer {
    display: flex;
    align-items: center;
    cursor: pointer;

    .tokenContainer {
      display: flex;
      align-items: center;

      .desktopTokens {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        border-radius: 16px;
        background: #fff;
        box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
          0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
        padding: 8px 10px;
      }
    }

    .sync {
      margin-left: 30px;
      border-radius: 16px;
      background: #fff;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
        0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
      padding: 8px 16px;
      display: flex;
      align-items: center;
      visibility: hidden;
    }

    .syncText {
      font-weight: 500;
      font-size: 14px;
      color: #1568bf;
      margin-right: 13px;
    }

    .tokens {
      margin: 0 5px 0 10px;
      font-size: 18px;
      font-weight: 500;
      color: #4b4b4b;
    }
  }

  .avatarStatusContainer {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;

    .avatarContainer {
      border-radius: 50%;
      background: #1568bf;
      width: 34px;
      height: 34px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      .nameInitials {
        color: #fff;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
      }
    }

    .loginStatus {
      border-radius: 50%;
      background-color: #309282;
      position: absolute;
      border: 2px solid #f7f7f7;
      bottom: 0;
      right: 0;
      width: 9px;
      height: 9px;
      z-index: 5;
    }

    .olvyTarget {
      margin: 0 3px;
    }

    .logoutDropDown {
      cursor: auto;
      position: absolute;
      width: 380px;
      right: 0;
      top: 45px;
      border: 1px solid #ccc;
      border-color: rgba(255, 255, 255, 0.7);
      border-radius: 4px;
      box-shadow: 2px 5px 10px 2px #ccc;
      background: white;
      padding: 15px 0 15px 0;
      z-index: 9;
      display: flex;
      flex-direction: column;
      align-items: center;

      .logoutDropdownHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;

        .avatarContainer {
          border-radius: 50%;
          background: #1568bf;
          width: 64px;
          height: 64px;
          overflow: hidden;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          .nameInitials {
            color: #fff;
            text-transform: uppercase;
            font-size: 27px;
            font-weight: 500;
          }
        }

        .userFullName {
          margin-top: 10px;
        }

        .userEmail {
          margin-top: 10px;
        }

        .userCompany {
          margin-top: 10px;
        }
      }

      .divider {
        width: 100%;
        margin: 10px 0 10px 0;
        background-color: #eee;
      }

      .fillContainer {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;

        .tooltipButton {
          cursor: pointer;
          width: 125px;
          background: white;
          color: black;
          padding: 10px 20px;
          font-size: 14px;
          font-weight: 500;
          border: 1px solid lightgrey;
          border-radius: 4px;

          &:hover {
            background: #eee;
          }
        }
      }

      .logoutDropdownFooter {
        padding: 10px 0 0 0;
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-evenly;

        a {
          text-decoration: none;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          color: #4b4b4b;
        }
      }
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 34px 14px;
    height: unset;
    flex-wrap: ${({ wrap }) => wrap};

    .titleContainer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
    }

    .mobileTokens {
      display: flex;
      align-items: center;
      margin-top: 11px;

      .tooltip {
        left: 13px !important;
      }

      .tooltip:after {
        margin-left: -22px !important;
      }

      .tokens {
        margin: 0 5px 0 10px;
      }
    }

    .tokenUserContainer {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .tokenContainer {
        display: flex;
        align-items: center;
        order: 2;

        .sync {
          margin-right: 0;
        }

        .desktopTokens {
          display: none;
        }
      }

      .tooltipContainer {
        margin: 0;
      }

      .tokens {
        margin: 0 0 0 10px;
        font-size: 18px;
        font-weight: 500;
        color: #4b4b4b;
      }
    }

    .mobile {
      width: 100%;

      .hamburgerIcon {
        position: absolute;
        left: 14px;
        top: 32px;
        cursor: pointer;

        svg {
          margin-right: 10px;

          &:first-child {
            margin-bottom: 5px;
          }
        }
      }
    }

    .switchPlaceholder {
      width: 70px;
      height: 20px;
    }

    .avatarStatusContainer {
      order: 1;
      margin: -25px 0 10px 50px;
    }
  }

  @media only screen and (max-width: 356px) {
    padding: 34px 8px;

    .mobileTokens {
      min-height: 41px;

      svg {
        width: 13px;
        height: 13px;
      }

      div svg {
        width: 9px;
        height: 9px;
        margin-top: 2px;
      }

      .tokens {
        margin: 0 -3px 0 5px;
        font-size: 0.7em;
      }
    }

    .avatarStatusContainer .logoutDropDown {
      width: 100vw;
    }
  }

  .goBack {
    display: flex;
    align-items: center;

    .__react_component_tooltip.place-bottom.type-dark#mcpTooltip {
      left: 215px !important;
      top: 47px !important;
    }
  }

  .tooltipContainer {
    margin: 0;

    .tooltip {
      background: #ffffff !important;
      border: 1px solid #1568bf !important;
      border-radius: 8px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
      padding: 10px 14px !important;
      color: #1568bf !important;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.5;
      text-align: center;
      width: max-content;
      max-width: 280px;
    }

    .__react_component_tooltip:before,
    .__react_component_tooltip:after {
      display: none !important;
    }
  }
`;

export default StyledHeader;
